__turbopack_context__.v({
  "button": "jkHasq_button",
  "container": "jkHasq_container",
  "discountDisabled": "jkHasq_discountDisabled",
  "discountEnabled": "jkHasq_discountEnabled",
  "label": "jkHasq_label",
  "total": "jkHasq_total",
  "value": "jkHasq_value",
});
